export default __webpack_public_path__ + "static/media/ecchatbot-logo.f694de5e.png";